.subtitle {
  margin-bottom: 1rem;
}
